import JWT from '../lib/jwt';

/**
 * Wrapper object to manage a Websocket connection to Authenticator server
 */
export default class {
  /**
   * Construct a new instance of Authenticator websocket connection
   *
   * @param {*} services Object containing services endpoints
   */
  constructor(services) {
    this._services = services;
    this._socket = null;
    this._callbacks = [];
  }

  /**
   * Connect to Authentication server via Websocket
   * Will attempt to authenticate after connection established
   */
  connect() {
    if (!this._socket || !this._socket.readyState > 1) {
      this._socket = this._services.websocket.socket('/socket');
      this._socket.onopen = () => this.authenticate();
      this._socket.onmessage = (msg) => {
        this._callbacks.forEach((cb) => cb(JSON.parse(msg.data)));
      };
    }
  }

  /**
   * Send a message to server over websocket
   *
   * @param {*} o Data to send in message
   */
  send(o) {
    if (this._socket && this._socket.readyState === 1) {
      this._socket.send(JSON.stringify(o));
    }
  }

  /**
   * Authenticate to websocket
   * Sends JWT across connection to establish authentication context
   */
  authenticate() {
    const token = localStorage.getItem('accessToken');
    if (token && JWT.parse(token).exp * 1000 > Date.now()) {
      this.send({
        type: 'authenticate',
        content: { token }
      });
    }
  }

  /**
   * Add a callback to be called when a message is received over websocket
   * Receives parsed JSON content as first parameter
   *
   * @param {Function} cb Function to be executed when message received
   */
  addMessageCallback(cb) {
    this._callbacks.push(cb);
  }

  /**
   * Remove callback from socket listener
   *
   * @param {Function} cb Callback to remove
   */
  removeMessageCallback(cb) {
    this._callbacks = this._callbacks
      .filter((f) => f !== cb);
  }
}
